import { Eyebrow, Reveal } from "./Reveal";

const BLOCKS = [
  {
    title: "We sign client NDAs.",
    text: "If you want one in place before you share the venue or the time, say so on the first call. We issue GST invoices.",
  },
  {
    title: "What we need from you.",
    text: "At minimum, the venue and the time at which we are to attend. For a date and a quote we also ask which areas are to be inspected and roughly how large they are. Why you are commissioning it is optional: sharing it helps the analysis a little.",
  },
  {
    title: "What we keep.",
    text: "Evidence photographs of findings are taken so that the premises cannot be identified; photographs that identify the premises are taken only if you ask. You keep one copy of the findings and notes. Our copy is held encrypted and kept for about a year, then destroyed.",
  },
];

export default function Confidentiality() {
  return (
    <section id="confidentiality" className="border-t border-hairline py-12 sm:py-16" data-testid="confidentiality-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>Confidentiality</Eyebrow>
          <h2 className="mt-4 font-head font-extrabold tracking-tight h-sec">
            Confidentiality.
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {BLOCKS.map(({ title, text }, i) => (
            <Reveal key={title} delay={i * 0.08} className="h-full">
              <div className="h-full border border-hairline bg-surface p-7" data-testid={`confidentiality-block-${i + 1}`}>
                <h4 className="font-head text-lg font-bold">{title}</h4>
                <p className="mt-3 text-base leading-relaxed text-sub">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
